export default __webpack_public_path__ + "static/veges-green-dark-d284974ff377b8704ef83a67cde99fc3.svg";